import purchrAxios from './purchrAxios';

export default class EmailService {
  static async forgotPassword(email) {
    console.log({ email });
    const response = await purchrAxios.post(
      `/email/forgot-password`,
      { email },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );

    console.log('forgot : ', response);

    return response.data;
  }

  static async sendVerificationEmail() {
    console.log('[DEBUG] sendVerificationEmail: Starting request to /email/verify');
    try {
      const response = await purchrAxios.post(`/email/verify`, {}, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      console.log('[DEBUG] sendVerificationEmail: Response received:', response);
      console.log('[DEBUG] sendVerificationEmail: Response status:', response.status);
      console.log('[DEBUG] sendVerificationEmail: Response data:', response.data);
      return response.data;
    } catch (error) {
      console.error('[DEBUG] sendVerificationEmail: Error occurred:', error);
      console.error('[DEBUG] sendVerificationEmail: Error response:', error.response);
      console.error('[DEBUG] sendVerificationEmail: Error message:', error.message);
      throw error;
    }
  }
}
